<template>
  <drop-helper :dropOptions="dropOptions"></drop-helper>
</template>

<script>
import DropHelper from '@/components/DragDrop/DropHelper';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  components: { DropHelper },
  props: ['item', 'preventDrop'],
  data() {
    return {
      accepts: ['page', 'noteCard'],
      firstDraggedItem: null,
      idsToMove: [],
      savedDragData: null
    };
  },
  watch: {
    draggedItems: function(n, o) {
      if (n[0]) {
        //  store the value of dragged data so when drag stops we still have it to execute on
        this.firstDraggedItem = n[0];
        this.idsToMove = this.draggedData.ids;
        this.savedDragData = this.draggedData;
      }
    }
  },
  computed: {
    ...mapGetters('pages', ['cardsByPage']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    dropOptions() {
      return {
        accepts: this.accepts,
        zones: [
          //  handle sorting questions
          {
            id: 'sortTop',
            show: this.isSortable && !this.isNextItem,
            style: {
              top: 0,
              left: 0,
              right: 0,
              height: 'auto',
              bottom: this.isPreviousItem ? 0 : '49%'
            },
            hoverWidth: 100,
            hoverClass: 'q-dropzone-top',
            targetCursor: true,
            onDrop: () => this.moveItem(this.isSortingForward ? -1 : 0)
          },
          {
            id: 'sortBottom',
            show: this.isSortable && !this.isPreviousItem,
            style: {
              top: this.isNextItem ? '1px' : '52%',
              height: 'auto',
              left: 0,
              right: 0,
              bottom: 0
            },
            hoverWidth: 100,
            targetCursor: true,
            hoverClass: 'q-dropzone-bottom',
            onDrop: () => this.moveItem(this.isSortingBack || !this.isSameSection ? 1 : 0)
          },
          {
            id: 'dropCard',
            show: this.isDroppable,
            style: {
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
            },
            hoverClass: 'q-dropzone-full',
            hoverWidth: 100,
            targetCursor: true,
            zoneText: '',
            zoneIcon: '',
            //hoverClass: 'hover-zone-move',
            onDrop: () => this.dropNoteCard()
          }
        ]
      };
    },
    active() {
      const matchedAccepts = this.accepts.filter(value => this.draggedData.types.includes(value));
      return this.dragging && matchedAccepts.length > 0;
    },
    draggedItems() {
      if (!this.active) {
        return [];
      }
      return this.draggedData.items;
    },
    isDragged() {
      return this.active && this.draggedData.ids.includes(this.item.id);
    },
    isSortable() {
      return this.active && !this.isDragged && this.draggedData.types.includes('page');
    },
    isSameSection() {
      return this.active && this.item.section == this.firstDraggedItem.section;
    },
    isDroppable() {
      return (
        this.active &&
        !this.isDragged &&
        this.draggedData.types.includes('noteCard') &&
        !this.isParentSection
      );
    },
    isParentSection() {
      return (
        this.draggedData.types.includes('noteCard') &&
        this.draggedData.items &&
        this.draggedData.parent.id == this.item.id
      );
    },
    isSortingBack() {
      return this.item.order < this.firstDraggedItem.order;
    },
    isSortingForward() {
      return this.item.order > this.firstDraggedItem.order;
    },
    isPreviousItem() {
      const firstDraggedItem = this.firstDraggedItem || {};
      return this.isSameSection && firstDraggedItem
        ? firstDraggedItem.order - 1 == this.item.order
        : false;
    },
    isNextItem() {
      const lastDraggedItem = this.draggedItems[this.draggedItems.length - 1] || {};
      return this.isSameSection && lastDraggedItem
        ? lastDraggedItem.order + 1 == this.item.order
        : false;
    }
  },
  methods: {
    ...mapActions('pages', ['movePage', 'moveCard']),
    moveItem(offsetOrder = 0) {
      this.movePage({
        pageId: this.idsToMove[0],
        toSection: this.item.section,
        toOrder: this.item.order + offsetOrder
      });
    },
    dropNoteCard() {
      console.log('move');
      const cards = this.cardsByPage[this.item.id];
      this.moveCard({
        fromPageId: this.savedDragData.parent.id,
        toPageId: this.item.id,
        cardId: this.idsToMove[0],
        order: cards.length
      });
    }
  }
};
</script>

<style>
/* .q-dropzone-left {
  border-left: 3px solid #2196f3;
}

.q-dropzone-right {
  border-right: 3px solid #2196f3;
  margin-right: -3px;
} */
/* .q-dropzone-merge {
  background: #2195f345;
}

.zone-merge .drop-zone-content {
  opacity: 0;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.zone-merge.hover .drop-zone-content {
  opacity: 1;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
} */
</style>
